import { getTestIds } from 'seagull/utils/TestIds';
export const GetServiceItemTID = (parentTestId)=>getTestIds({
        parentTestId
    });
